import { render, staticRenderFns } from "./PESVFichaIndicadores.vue?vue&type=template&id=2433829c"
import script from "./PESVFichaIndicadores.vue?vue&type=script&lang=js"
export * from "./PESVFichaIndicadores.vue?vue&type=script&lang=js"
import style0 from "./PESVFichaIndicadores.vue?vue&type=style&index=0&id=2433829c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports